var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"id":"ourInfo","align-h":"center"}},[_c('b-row',[_c('b-col',[_c('h1',{attrs:{"id":"ourName"}},[_vm._v(_vm._s(_vm.bride)+" "),_c('span',{attrs:{"id":"and"}},[_vm._v("&")]),_vm._v(" "+_vm._s(_vm.groom))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }